import type { TimelineTranslations } from "../../types/timeline";

export const timeline: TimelineTranslations = {
  loading: "Ajatelje laadimine...",
  failedLoad: "Ajatelje laadimine eba\u00F5nnestus",
  noDocuments: "Dokumente ei leitud",
  uploadPrompt: "Laadige dokument \u00FCles, et n\u00E4ha seda ajateljel",
  documentCount: "{count} dokumenti",
  showingCount: "(n\u00E4idatakse {count})",
  loadMore: "Laadi rohkem dokumente",
  hintZoomScroll: "Vihje: Hoidke Cmd/Ctrl klahvi ja kerige suumimiseks",
  hintZoomScrollInfinite:
    "Vihje: Hoidke Cmd/Ctrl klahvi ja kerige suumimiseks. Kerige alla, et laadida rohkem dokumente.",
  loadingDocuments: "Dokumentide laadimine...",
  documentsOfTotal: "{loaded} dokumenti {total}-st",
  loadingMore: "Laadin rohkem...",
  selectDocument: "Vali dokument {filename}",
  viewDocument: "Vaata {filename}",
  addedBy: "Lisas {name}",
  uploaded: "Üles laaditud",
  downloadDocument: "Lae alla {filename}",
  zoomOut: "V\u00E4henda",
  zoomLevelAriaLabel: "Ajatelje suumi tase",
  zoomIn: "Suurenda",
  documentSingular: "dokument",
  documentPlural: "dokumenti",
  clusterDocumentsOf: "{loaded}/{total} dokumenti",
  clusterAriaLabel: "{count} dokumenti ajavahemikust {dateRange}, kl\u00F5psa {action}",
  clusterActionExpand: "laiendamiseks",
  clusterActionView: "vaatamiseks",
  dateBasis: {
    label: "Kuup\u00E4ev",
    upload: "\u00DCleslaadimine",
    creation: "Loomine",
    uploadTooltip:
      "Paiguta dokumendid selle j\u00E4rgi, millal need Franklinisse \u00FCles laaditi \u2014 platvormi enda \u00FCleslaadimise kuup\u00E4ev ja kellaaeg.",
    creationTooltip:
      "Paiguta dokumendid iga faili metaandmetesse salvestatud loomise v\u00F5i muutmise kuup\u00E4eva j\u00E4rgi. Kuup\u00E4evata failid paigutatakse \u00FCleslaadimise kuup\u00E4eva j\u00E4rgi.",
    uploadUnavailableTooltip:
      "\u00DCleslaadimise kuup\u00E4eva j\u00E4rgi paigutamine pole veel saadaval. See lisandub j\u00E4rgmise platvormi uuendusega.",
  },
  zoomGranularity: {
    years: "Aastad",
    months: "Kuud",
    weeks: "N\u00E4dalad",
    days: "P\u00E4evad",
    hours: "Tunnid",
    minutes: "Minutid",
  },
  granularitySummary: {
    year: "{count} aastat",
    month: "{count} kuud",
    week: "{count} n\u00E4dalat",
    day: "{count} p\u00E4eva",
  },
  viewMode: {
    list: "Nimekiri",
    listAriaLabel: "Nimekirja vaade",
    timeline: "Ajatelg",
    timelineAriaLabel: "Ajatelje vaade",
  },
};
